
import { Component, EventEmitter, Output } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { ButtonModule } from '@components/button';

@Component({
  selector: 'waiting-for-call',
  imports: [
    CsIconModule,
    ButtonModule
],
  templateUrl: './waiting-for-call.component.html',
})
export class WaitingForCallComponent {
  @Output() buttonClicked = new EventEmitter<void>();

  onSubmit(): void {
    this.buttonClicked.emit();
  }
}
